import React from "react"
import AIModalJson from "../../Configs/JSON/MobileModal.json"
import "../../styles/calculator/AnnualIncomeModal.less"
import GenericModal from "../Common/GenericModal"
import CircleIcon from "../Common/CircleIcon"
import { observer } from "mobx-react"
import AppStore from "../../Configs/Store/index"
import FormStore from "../../Configs/Store/forms"

const MobileModal = observer(() => {
  return (
    <>
      <GenericModal
        visibleState={FormStore.calc_mobModal}
        updateVisibility={() => FormStore.setMobileModal(false)}
        closeIcon={<CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />}
        rootClassAntCustom={"AnnualIncomeModal"}
        showButton={true}
        buttonText={AIModalJson["buttonText"]}
        // buttonStyle={"OKButton"}
        buttonWrapper={"calculateFormDiv"}
        buttononClick={() => FormStore.setMobileModal(false)}
        component={
          <div className="contentWrap">
            <CircleIcon iconStyle="titleICon" iconUrl={AIModalJson["mainIcon"]} imgwidth={AIModalJson["imgwidth"]} imgheight={AIModalJson["imgheight"]} imgalt={AIModalJson["imgalt"]} />
            <div className="SectionTitle">{AIModalJson["modalTitle"]}</div>
            <div className="content">{AIModalJson["modalContent"]}</div>
          </div>
        }
      />
    </>
  )
})

export default MobileModal
